 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"group-albums":"group-albums","group-articles":"group-articles","group-profile":"group-profile","group-schools":"group-schools","group-tasks":"group-tasks","group-videos":"group-videos"}[chunkId]||chunkId) + "." + {"chunk-0bc701e7":"8fb478fe","chunk-2c552066":"60129577","chunk-2c5f2b76":"61d98f88","chunk-2d0a2db0":"972720df","chunk-2d0be333":"2f86a247","chunk-2be659ec":"bea5fe2d","chunk-2d21e3a2":"a490e8ac","chunk-f41303f8":"aef55edc","chunk-fe350512":"9bf90108","chunk-2d0d7fa9":"58e07f4e","chunk-2d0db077":"f92b8ca6","chunk-2d2086b7":"e5c4417f","chunk-2d21e007":"514fcb64","chunk-306a4cd1":"f19386c4","chunk-39455d3c":"64bd8108","chunk-3bce4054":"9de12cdc","group-albums":"f08e717b","chunk-3bcb62a2":"0379fc48","chunk-3c9739b4":"93638e69","chunk-cbc4b020":"6d02db7e","chunk-4f93c610":"9ab35fd0","chunk-53acbf5c":"05c17493","chunk-549200c0":"9904b94e","chunk-5b1e9b63":"0dcefb84","chunk-703cd8e1":"10a66e28","chunk-7683232c":"9efe8f2c","chunk-cdfa9f1e":"912d9e9a","chunk-d98a17d6":"521ba548","chunk-fa3ae5a6":"acf52383","group-articles":"bfa765bd","group-profile":"ee2ba3ab","group-schools":"6750bae6","group-tasks":"2ba7222d","group-videos":"f64e6d94","chunk-299f5ca9":"91aacffa","chunk-6bd1b653":"cc1f7507","chunk-2d0d3de4":"ff9a5ecb","chunk-2d21dabe":"565dee66","chunk-70ff432a":"abc7851d","chunk-72dfebf0":"d0c9c165"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0bc701e7":1,"chunk-2c552066":1,"chunk-2c5f2b76":1,"chunk-2be659ec":1,"chunk-f41303f8":1,"chunk-fe350512":1,"chunk-3bce4054":1,"group-albums":1,"chunk-3c9739b4":1,"chunk-cbc4b020":1,"chunk-549200c0":1,"chunk-5b1e9b63":1,"chunk-7683232c":1,"chunk-cdfa9f1e":1,"chunk-d98a17d6":1,"chunk-fa3ae5a6":1,"group-articles":1,"group-schools":1,"group-tasks":1,"group-videos":1,"chunk-299f5ca9":1,"chunk-6bd1b653":1,"chunk-72dfebf0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"group-albums":"group-albums","group-articles":"group-articles","group-profile":"group-profile","group-schools":"group-schools","group-tasks":"group-tasks","group-videos":"group-videos"}[chunkId]||chunkId) + "." + {"chunk-0bc701e7":"ff9442e7","chunk-2c552066":"ff9442e7","chunk-2c5f2b76":"ff9442e7","chunk-2d0a2db0":"31d6cfe0","chunk-2d0be333":"31d6cfe0","chunk-2be659ec":"9d6bc25c","chunk-2d21e3a2":"31d6cfe0","chunk-f41303f8":"9b7b1be0","chunk-fe350512":"10088c83","chunk-2d0d7fa9":"31d6cfe0","chunk-2d0db077":"31d6cfe0","chunk-2d2086b7":"31d6cfe0","chunk-2d21e007":"31d6cfe0","chunk-306a4cd1":"31d6cfe0","chunk-39455d3c":"31d6cfe0","chunk-3bce4054":"07d43154","group-albums":"c6ce6262","chunk-3bcb62a2":"31d6cfe0","chunk-3c9739b4":"279afe2a","chunk-cbc4b020":"3cbbd162","chunk-4f93c610":"31d6cfe0","chunk-53acbf5c":"31d6cfe0","chunk-549200c0":"ff9442e7","chunk-5b1e9b63":"ff9442e7","chunk-703cd8e1":"31d6cfe0","chunk-7683232c":"ff9442e7","chunk-cdfa9f1e":"ff9442e7","chunk-d98a17d6":"1b902841","chunk-fa3ae5a6":"ff9442e7","group-articles":"541aed9a","group-profile":"31d6cfe0","group-schools":"ffa5c71b","group-tasks":"48c0f3d8","group-videos":"ff9442e7","chunk-299f5ca9":"5da4b91a","chunk-6bd1b653":"0a84c08b","chunk-2d0d3de4":"31d6cfe0","chunk-2d21dabe":"31d6cfe0","chunk-70ff432a":"31d6cfe0","chunk-72dfebf0":"c338e31c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
